import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormsModule} from "@angular/forms";
import {NgClass} from "@angular/common";
import {NgxCurrencyDirective, NgxCurrencyInputMode} from "ngx-currency";

@Component({
  selector: 'app-currency-input',
  imports: [
    FormsModule,
    NgxCurrencyDirective,
    NgClass
  ],
  templateUrl: './currency-input.component.html',
  styleUrl: './currency-input.component.scss'
})
export class CurrencyInputComponent {
  constructor() {
  }

  @Input() negative: boolean = true;
  @Input() placeholder: string = "";
  @Input() readonly: boolean = false;
  @Input() colored: boolean = false;

  _input: number | null = null;
  @Input() set input(value: number | null) {
    this._input = value;
    this.inputChange.emit(value);
  }

  get input(): number | null {
    return this._input;
  }

  @Output() inputChange = new EventEmitter<number | null>();
  protected readonly NgxCurrencyInputMode = NgxCurrencyInputMode;
}
